import type { ModifierArguments } from '@popperjs/core';

export const PAGE_SIZE = 10;

export const POPPER_ANCHOR_GAP_PX = 8;
export const POPPER_VIEWPORT_MARGIN_BOTTOM_PX = 150;
export const POPPER_MIN_HEIGHT_PX = 120;
export const POPPER_MAX_HEIGHT_PX = 600;
export const TARGET_TEXT_MAX_LENGTH = 100;

export const stripHighlight = (text: string) => (text || '').replace(/<[^>]*>/g, '');

export const getItemHref = (item: Search.Static & Search.WithSearchText) => {
    const raw = item.searchText ? item.searchText.slice(0, TARGET_TEXT_MAX_LENGTH) : '';
    const textFragment = raw ? `?searchText=${encodeURIComponent(raw)}` : '';
    return `/${item.id}${textFragment}`;
};

export function createStaticSearchPopperMaxHeightModifier(applyMinHeight: boolean) {
    return {
        enabled: true,
        fn({ state }: ModifierArguments<any>) {
            if (typeof window === 'undefined') {
                return;
            }
            const vv = window.visualViewport;
            const viewportBottom = vv ? vv.pageTop + vv.height : window.innerHeight;
            // @ts-ignore
            const top = state.scrollParents.popper?.[0]?.getBoundingClientRect()?.top;
            const y = top + window.scrollY;
            const availableSpace = viewportBottom - y;

            const rawMax = Math.floor(availableSpace - POPPER_VIEWPORT_MARGIN_BOTTOM_PX - POPPER_ANCHOR_GAP_PX);

            let nextStyles: Record<string, string>;

            if (applyMinHeight) {
                const maxPopperPx = Math.min(POPPER_MAX_HEIGHT_PX, Math.max(POPPER_MIN_HEIGHT_PX, Math.max(0, rawMax)));
                nextStyles = {
                    maxHeight: `${maxPopperPx}px`,
                    minHeight: `${POPPER_MIN_HEIGHT_PX}px`,
                };
            } else {
                const maxPopperPx = rawMax > 0 ? Math.min(POPPER_MAX_HEIGHT_PX, rawMax) : POPPER_MAX_HEIGHT_PX;
                nextStyles = {
                    maxHeight: `${maxPopperPx}px`,
                    minHeight: 'auto',
                };
            }
            // eslint-disable-next-line no-param-reassign -- Popper modifier contract mutates `state.styles`
            state.styles.popper = {
                ...state.styles.popper,
                ...nextStyles,
            };
        },
        name: 'staticSearchPopperMaxHeight',
        phase: 'beforeWrite' as const,
        requires: ['computeStyles'],
    };
}
